import { ROLES } from '@/constants/roles';

export default [
  {
    path: '/consignments',
    name: 'consignments',
    component: () => import('@/views/pages/consignments/ConsignmentList.vue'),
    meta: {
      pageTitle: 'Consignments',
      breadcrumb: {
        label: 'Consignments'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN, ROLES.CUSTOMER_MANAGER, ROLES.CUSTOMER_USER],
      verticalMenu: {
        title: 'Consignments',
        icon: 'GridIcon'
      }
    }
  },
  {
    path: '/consignments/bulk-import',
    name: 'bulk_shipment_import',
    component: () => import('@/views/pages/consignments/BulkShipmentImportPage.vue'),
    meta: {
      layout: 'full',
      pageTitle: 'Bulk Shipment with Excel',
      breadcrumb: {
        label: 'Toplu Sevkiyat'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN, ROLES.CUSTOMER_MANAGER, ROLES.CUSTOMER_USER]
    }
  },
  {
    path: '/consignments/create',
    name: 'create_consignment',
    component: () => import('@/views/pages/consignments/CreateConsignmentNew.vue'),
    meta: {
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN, ROLES.CUSTOMER_MANAGER, ROLES.CUSTOMER_USER],
      verticalMenu: {
        title: 'Create Consignment',
        icon: 'PlusIcon'
      }
    }
  },
  {
    path: '/consignments/:id',
    name: 'consignments_detail',
    component: () => import('@/views/pages/consignments/ConsignmentDetails.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: {},
      navActiveLink: 'consignments',
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN, ROLES.CUSTOMER_MANAGER, ROLES.CUSTOMER_USER]
    }
  },
  {
    path: '/consignments/edit/:id',
    name: 'consignments_edit',
    component: () => import('@/views/pages/consignments/EditConsignment.vue'),
    meta: {
      pageTitle: 'Edit Consignment',
      breadcrumb: {
        label: 'Edit Consignment',
        parent: 'consignments'
      },
      navActiveLink: 'consignments',
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN, ROLES.CUSTOMER_MANAGER, ROLES.CUSTOMER_USER]
    }
  }
];
